import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { getSearchResults } from '../redux/reducers/searchResults'
import { getTours } from '../redux/reducers/tours'

export function useSearchResults() {
  const searchResults = useSelector(getSearchResults)
  const tours = useSelector(getTours)

  return useMemo(() => {
    return _.isEmpty(searchResults)
      ? tours
      : _.filter(_.at(tours, searchResults))
  }, [searchResults, tours])
}
